import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('nile-rte-toolbar-item')
export class NileRteToolbarItem extends LitElement {
  protected createRenderRoot() { return this; }
  protected shouldUpdate() { return false; }

  @property({ type: String, attribute: true, reflect: true }) name = '';
  @property({ type: String, attribute: true, reflect: true }) label = '';

}
declare global { interface HTMLElementTagNameMap { 'nile-rte-toolbar-item': NileRteToolbarItem; } }
